import React from 'react';

import Image from 'next/image';

import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  useMediaQuery,
} from '@mui/material';

import { useTheme } from '@mui/material/styles';

import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-mui';
import * as Yup from 'yup';

import ReCAPTCHA from "react-google-recaptcha";

import mobileRegex from '../../constants/mobileRegex';

import axiosInstance from '../../lib/axiosInstance';


const ContactSchema = Yup.object().shape({
  user_name: Yup.string()
    .max(100, 'Only 100 characters allowed')
    .required('Please enter your name'),
  user_email: Yup.string()
    .email('Invalid email')
    .required('Please enter your email'),
  user_number: Yup.string()
    .matches(mobileRegex, 'The mobile number you provided is not valid')
    .required('Please enter your contact number'),
  message: Yup.string()
    .required('Please tell us what you want to say to us'),
  recaptcha: Yup.string()
    .required(),
});

const ContactDialog = ({data, open, handleClose}) => {
  
  const [sent, setSent] = React.useState(false);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const maxWidth = useMediaQuery(theme.breakpoints.up('md')) ? "sm" : false;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth
      fullScreen={fullScreen}
    >
      {!sent && <Box
        p={4}
        // display="flex"
        alignItems="center"
        bgcolor="primary.dark"
      >
        <Box color="white" fontSize="h4.fontSize">{data.name}</Box>
        <Box color="primary.light">Your message will be sent by email</Box> 
      </Box>}
      <DialogContent
        sx={{
          mt: 4,
          '& .MuiTextField-root': {
            mb: 2
          },
        }}
      >
        {!sent &&
        <Formik
          initialValues={{
            user_name: '',
            message: '',
            user_email: '',
            user_number: '',
            recaptcha: ''
          }}
          validationSchema={ContactSchema}
          onSubmit={(values, { setSubmitting }) => {
            axiosInstance.post(
              `/content/profile-message/`,
              {
                ...values,
                business: data.id
              }
            ).then(response => {
              setSubmitting(false);
              setSent(true);
              setTimeout(() => {
                handleClose();
              }, 5000)
            }).catch(error => {
              console.log(error);
              setSubmitting(false);
            });
          }}
        >
          {({ submitForm, isSubmitting, setFieldValue }) => (
            <Form>
              <Field
                component={TextField}
                label="Your Name"
                placeholder="Enter your name"
                name="user_name"
                variant="outlined"
                fullWidth
              />
              <Field
                component={TextField}
                name="message"
                label="Your Message"
                placeholder="Type your message or ask your question here"
                variant="outlined"
                fullWidth
                multiline
                rows={4}
              />
              <Field
                component={TextField}
                name="user_email"
                type="email"
                label="Email Address"
                variant="outlined"
                fullWidth
              />
              <Field
                component={TextField}
                name="user_number"
                label="Contact Number"
                variant="outlined"
                fullWidth
              />

              <Box display="flex" justifyContent="center">
                <ReCAPTCHA
                  sitekey="6LePb-8UAAAAAB9ODTrFKU3x4kTHRZ-4Mr6ZipON"
                  onChange={response => setFieldValue("recaptcha", response)}
                />
              </Box>

              <Backdrop
                open={isSubmitting}
                sx={{
                  zIndex: theme => theme.zIndex.drawer + 1,
                  color: '#fff',
                }}
              >
                <CircularProgress color="inherit" />
              </Backdrop>

              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={isSubmitting}
                  onClick={submitForm}
                >
                  Submit
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>}
        {sent &&
          <Box textAlign="center">
            <Box
              fontSize="h4.fontSize"
              textAlign="center"
              mb={2}
            >
              Your message is on its way!
            </Box>
            <Image
              src="/icons/receive-quotes.svg"
              alt="Negotiate"
              width={200}
              height={200}
            />
          </Box>
        }
      </DialogContent>
    </Dialog>
  )
}

export default ContactDialog;
